<template>
  <div>
   <Header />
    <Info />
    <Banner />
    <div class="main">
      <div class="container">
        <router-view />
      </div>
    </div>
    <Cookie />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header'
import Info from './components/Info'
import Banner from './components/Banner'
import Footer from '@/pocztapolska/components/Footer'
import Cookie from '@/pocztapolska/components/Cookie'

export default {
  components: {
    Cookie,
    Footer,
    Banner,
    Header,
    Info
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
